import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 12h14l-7 -8l-7 8","key":"svg-0"}],["path",{"d":"M5 17a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1l0 -2","key":"svg-1"}]]

const IconPlayerEject = createReactComponent('outline', 'player-eject', 'PlayerEject', __iconNode);

export default IconPlayerEject;